import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateVehicle, Vehicle } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { driverKeys } from '../../drivers/api';
import { createVehicleApi, vehicleKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useCreateVehicle(): UseMutationResult<Vehicle, Error, CreateVehicle> {
  const client = useApiClient('admin-auth');
  const api = createVehicleApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<Vehicle, Error, CreateVehicle>({
    mutationFn: (body: CreateVehicle) => api.createVehicle(body),
    ...createMutationCallbacks({
      invalidateKeys: [vehicleKeys.all, driverKeys.all],
      queryClient,
      successKey: 'vehicles.toast.createSuccess',
      t,
    }),
  });
}
